export const periodTooltipStyles = {
  select: {
    m: 0,
    height: '40px',
    minHeight: '40px',
    background: '#FFFFFF',
    borderRadius: '4px',

    '& .MuiSelect-select': {
      top: '-2px',
    },
  },
};
